'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Названия типов модальных окон
 * @type {string}
 */
var ADD = exports.ADD = 'add';
var DELETE = exports.DELETE = 'del';
var EDIT = exports.EDIT = 'edit';
var INFO = exports.INFO = 'info';
var SAVE = exports.SAVE = 'save';
var ADD_TO_CART = exports.ADD_TO_CART = 'addToCart';
var ALCOHOL_MODAL = exports.ALCOHOL_MODAL = 'alcoModal';
var MODIFIER_MODAL = exports.MODIFIER_MODAL = 'modifierModal';
var BUY_IN_CREDIT_MODAL = exports.BUY_IN_CREDIT_MODAL = 'BuyInCreditModal';
var AUTH = exports.AUTH = 'auth';
var AUTH_ONE_CLICK = exports.AUTH_ONE_CLICK = 'authOneClick';
var REGISTRATION = exports.REGISTRATION = 'registration';
var CONFIRM_PHONE = exports.CONFIRM_PHONE = 'confirmPhone';
var CONFIRM_CHANGE_PHONE = exports.CONFIRM_CHANGE_PHONE = 'confirmChangePhone';
var CONFIRM_MAIL = exports.CONFIRM_MAIL = 'confirmMail';
var PASSWORD_CHANGE = exports.PASSWORD_CHANGE = 'password_change';
var CONFIRM_OLD_MAIL = exports.CONFIRM_OLD_MAIL = 'confirmOldMail';
var PASS_RECOVERY = exports.PASS_RECOVERY = 'passRecovery';
/** Открытие модального окна с картой */
var MAP_MODAL = exports.MAP_MODAL = 'mapModal';
/** Сохранение прошло успешно */
var SAVE_SUCCESS = exports.SAVE_SUCCESS = 'successfulSave';


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/constants.js
// module id = 752
// module chunks = 0